import { IMaintenanceState } from '@/store/maintenance';
import { IMaintenanceGetters } from './getters.types';
import { IMaintenance, Maintenance } from '@/models';
import moment from 'moment';

const DAYS_IN_WEEK = 7;

export const getters: IMaintenanceGetters = {
  getMaintenances(state: IMaintenanceState): IMaintenance[] {
    return state.maintenances.map(data => new Maintenance(data));
  },

  getMaintenanceById: (state: IMaintenanceState) => (
    id: number
  ): IMaintenance | undefined => {
    const data = state.maintenances.find(maintenance => maintenance.id === id);
    if (!data) {
      return undefined;
    }

    return new Maintenance(data);
  },

  getNearestMaintenance: (
    state: IMaintenanceState
  ): IMaintenance | undefined => {
    const currentDate = () => new Date(); // Arrow functon to get new instance every callback
    const data = state.maintenances.find(maintenance => {
      const daysTillMaintenance = moment(maintenance.start).diff(
        currentDate(),
        'days'
      );

      // get current maintain object or get closest maintaince within a week
      return daysTillMaintenance < DAYS_IN_WEEK;
    });
    if (!data) {
      return undefined;
    }

    return new Maintenance(data);
  }
};
